export default {
  title: 'Wachtwoord opnieuw instellen',
  description: 'We sturen een wachtwoordherstelkoppeling naar uw e-mailadres.',
  sent: 'E-mail is verzonden.',

  form: {
    email: {
      title: 'E-mail',
      placeholder: 'E-mailadres invoeren',
    },
    button: {
      title: 'Wachtwoord opnieuw instellen',
    },
    error_messages: {
      error1: 'Ontbrekende informatie',
    },
  },
};
